import { useMemo } from 'react';
import shallow from 'zustand/shallow';
import useStore from '~/store';

const selector = (s) => ({ age: s.age, leftData: s.leftData, rightData: s.rightData });

export default function useDatum() {
  // change to leftDatum, rightDatum
  const { age, leftData, rightData } = useStore(selector, shallow);

  const leftDatum = useMemo(() => {
    if (!leftData) {
      return null;
    }
    return leftData.find((d) => d.Alter === age);
  }, [age, leftData]);

  const rightDatum = useMemo(() => {
    if (!rightData) {
      return null;
    }
    return rightData.find((d) => d.Alter === age);
  }, [age, rightData]);

  return {
    leftDatum,
    rightDatum,
  };
}
